import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router";
import Header from "./Header";
import Footer from "../Footer";
import fire from "./Firebase";
import "../App.css";

function CertificateTemp4() {
  document.title = "HR School-Template 4";
  const [temp4, settemp4] = useState({});
  const conponentPDF = useRef();
  useEffect(() => {
    fire.child("certificates").on("value", (data) => {
      if (data.val() == null || data.val() == "") alert("Data Fetch");
      else {
        settemp4(data.val());
      }
      console.log(data.val());
    });
  }, []);
  const navigate = useNavigate();
  function generatePDF(keys) {
    sessionStorage.setItem("lastname4", keys);
    navigate("/try4");
  }

  return (
    <div>
      <Header />
      <center>
        {" "}
        <h1>Download PDF Certificate</h1>
      </center>
      <div id="maindiv" ref={conponentPDF}>
        {Object.keys(temp4).map((all, index) => {
          return (
            <>
              <div style={{ margin: "20px",textTransform:"uppercase" }}>
                <div className="temp4container relative">
                  <div className="temp4background relative">
                    <div className="content-wrapper">
                      <div className="temp4header relative">
                        <div className="logo-mitra-wrapper title-top1">
                          HR School
                        </div>
                      </div>

                      <p className="title-top">CERTIFICATE OF COMPLETION</p>
                      <p className="title-bottom">
                        CERTIFIED {temp4[all].Field} SPECIALIST
                      </p> <br />
                      <p>THIS IS TO CERTIFY THAT</p>
                      <p className="temp4name">NAME :- {temp4[all].Gender} {temp4[all].Name}</p>
                      <p className="temp4name">
                        FATHER NAME :- {temp4[all].Father}
                      </p>
                      <p className="temp4name">
                        COURSE DURATION :- {temp4[all].Course} MONTHS
                      </p>
                      <p className="temp4name">
                        COURSE NAME :- {temp4[all].Coursename}
                      </p>
                      <hr className="divider" />
                      <p className="completing">
                        THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                        TAKE IT AWAY FROM YOU.
                      </p>
                      <p className="course-title">
                        HAS SUCCESSFULLY COMPLETED THE {temp4[all].Coursename}{" "}
                        COURSE WITH HR SCHOOL
                      </p>
                      <p className="course-title2">
                        {" "}
                        WITH SCORE OF {temp4[all].grade}
                      </p>
                      <p className="course-title2">Dated</p>
                      <p className="course-title3">
                        START DATE :- {temp4[all].startdate}/{temp4[all].startmonth}/{temp4[all].startyear}
                      </p>
                      <p className="course-title3">
                        END DATE :- {temp4[all].enddate}/{temp4[all].endmonth}/{temp4[all].endyear}
                      </p>
                      <p className="course-title2">www.hrschool.com</p>

                      <div className="left-block"></div>
                      <div className="right-block"></div>
                    </div>
                  </div>
                </div>
              </div>
              <center>
                  {" "}
                  <br />
                  <button onClick={() => generatePDF(all)}>
                  Download {temp4[all].Name} Image
                  </button>
                </center>
            </>
          );
        })}{" "}
      </div>
    </div>
  );
}

export default CertificateTemp4;
